var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPhoneWhile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.32,
    height: 21.32,
    viewBox: "0 0 21.32 21.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-alt",
    "data-name": "Icon awesome-phone-alt",
    d: "M20.711,15.066l-4.664-2a1,1,0,0,0-1.166.287l-2.065,2.523A15.434,15.434,0,0,1,5.438,8.5L7.962,6.434a1,1,0,0,0,.287-1.166L6.25.6A1.006,1.006,0,0,0,5.105.026l-4.331,1A1,1,0,0,0,0,2,19.319,19.319,0,0,0,19.321,21.32a1,1,0,0,0,.974-.775l1-4.331a1.011,1.011,0,0,0-.583-1.149Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPhoneWhile);
export default __webpack_public_path__ + "static/media/icons-phone-while.e4d8ba454aeb62fab46099b2238d7dc0.svg";
export { ForwardRef as ReactComponent };